import type { IsSummaryWorthyDataFetchSource } from "owa-copilot-meeting-prep-utils";
import type { AccountKey } from "owa-client-types";
import { action } from "satcheljs";

export type SummaryWorthyCompletionOutcome = "positive" | "negative" | "unavailable" | "timeout";

export interface SummaryWorthyCompletionObservation {
    accountKey: AccountKey;
    eventId: string;
    outcome: SummaryWorthyCompletionOutcome;
    dataFetchSource: IsSummaryWorthyDataFetchSource;
    wasCached: boolean;
    ocsDurationMs: number;
    completionTimestampMs: number;
    correlationId?: string;
}

export interface SummaryWorthyCompletionObservationActionMessage {
    observation: SummaryWorthyCompletionObservation;
}

export const summaryWorthyCompletionObserved: (observation: SummaryWorthyCompletionObservation) => SummaryWorthyCompletionObservationActionMessage = action("summaryWorthyCompletionObserved", (observation: SummaryWorthyCompletionObservation): SummaryWorthyCompletionObservationActionMessage => ({
    observation,
}));
